/**
 * @Description 商圈详情-数据说明弹窗
 * 从选址地图页迁移出来的
 * 注意该页面被选址地图分享页也引用了，修改时要注意影响范围
 */

import { Modal } from 'antd';
import styles from './index.module.less';
import { markTypeEnum } from '@/views/iterate/pages/siteselectionmapb/ts-config';
import { FC, useContext, useMemo } from 'react';
import { globalOpeningAreaAlias } from '@/common/utils/ways';
import UserInfoContext from '@/layout/context';
import { isNotEmptyAny } from '@lhb/func';

// 四维文案，四条描述
const fourDimensionDescription = [
  '人口客群：人越多的地方评分越高（包含居住、商场客流、办公等人口）',
  '区域特征：配套越好评分越高（包含餐饮、生活服务、购物、休闲娱乐、商业住宅办公、交通等）',
  '消费能力：消费力越强评分越高（包含餐饮客单价、房价）',
  '门店经营：存续3年以上老店密度越高评分越高（统计近5年的餐饮门店）',
];

interface DataInfoModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  markType: number;
  shareParams?: any;
  isSemirModel?: boolean;
}


const DataInfoModal:FC<DataInfoModalProps> = ({ open, setOpen, markType, shareParams,
  isSemirModel
}) => {
  const { tenantInfo: { globalAliasItemVOs } } = useContext(UserInfoContext); // 租户信息

  const openingAreaTaskAlias = useMemo(() => {
    if (isNotEmptyAny(shareParams) && shareParams?.globalAliasItemVOs) return globalOpeningAreaAlias(shareParams.globalAliasItemVOs);
    return globalOpeningAreaAlias(globalAliasItemVOs);
  }, [globalAliasItemVOs, shareParams]);

  // 五维文案，五条描述
  const fiveDimensionDescription = [
    `人口客群：根据周边500m的居住人口、办公人口、商场客流人口计算，评分越高代表该${openingAreaTaskAlias}人越多。`,
    `区域特征：根据周边500m的商业、住宅、办公、交通、生活服务等计算，评分越高代表${openingAreaTaskAlias}配套越完善。`,
    `消费能力：根据周边500m的餐饮消费客单价、房价计算，评分越高代表${openingAreaTaskAlias}消费能力越强。`,
    `业态氛围：根据周边500m的同行业门店、协同业态门店计算，评分越高代表该${openingAreaTaskAlias}内品牌经营氛围越好。`,
    `销售潜力：基于历史门店经营情况，通过大数据测算${openingAreaTaskAlias}内品牌营业额，评分越高代表该${openingAreaTaskAlias}内品牌经营氛围越好。`,
  ];

  // 六维文案，五维基础上增加一条描述
  const sixDimensionDescription = [
    ...fiveDimensionDescription,
    `行业评分：根据周边的同行业门店数、开闭店数计算，评分越高代表该${openingAreaTaskAlias}内此行业经营氛围越好。`
  ];



  const dimensionCount = useMemo(() => {
    return [markTypeEnum.four, markTypeEnum.five, markTypeEnum.six].includes(markType) ? markType : markTypeEnum.four;
  }, [markType]);

  const dimensionDescription = useMemo(() => {
    if (markType === markTypeEnum.six) {
      return sixDimensionDescription;
    } else if (markType === markTypeEnum.five) {
      return fiveDimensionDescription;
    } else {
      return fourDimensionDescription;
    }
  }, [markType]);

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      width='680px'
      title='数据说明'
      centered
      footer={null}
    >
      <div className={styles.dataInfoContent}>
        {
          isSemirModel ? <></> : <>
            <div className={styles.infoItem}>统计范围：{openingAreaTaskAlias}详情数据统计范围为中心点周边500米</div>
            <div className={styles.infoSubTitle}>【{openingAreaTaskAlias}市场评分】</div>
            <div className={styles.infoItem}>通过以下{dimensionCount}个综合指标，客观评估得出</div>
            {dimensionDescription.map((itm: any, idx: number) => (
              <div key={idx} className={styles.infoItem}>{itm}</div>
            ))}</>
        }
        <div className={styles.infoSubTitle}>【历史经营门店】</div>
        <div className={styles.infoItem}>沉淀位置厂商历年门店数据及Location大数据整合测算得出，数据从2018年3月开始记录，每月进行更新。</div>
        <div className={styles.infoSubTitle}>【居住人口&画像】</div>
        <div className={styles.infoItem}>基于官方统计、位置厂商数据及Location大模型。根据城市人口、居住密度、商场客流画像、范围内住宅小区、生活配套数量等数据进行人口算法模型测算。</div>
        <div className={styles.infoSubTitle}>【周边配套】</div>
        <div className={styles.infoItem}>基于位置厂商数据及Location大数据整合。</div>
      </div>
    </Modal>
  );
};

export default DataInfoModal;
